import actionCreatorFactory from "typescript-fsa"; // FSA = Flus Standard Actions; has properties type, payload, error (whether payload is error object; optional) and meta (optional).

import * as toastr from "toastr";

import { DataService } from "../data/DataService";

import { ICalendarSettingsFromService_AddEditEvent } from "../classes/data";

import * as types from "./actionTypes";

import { beginAjaxCall } from "./ajaxActions";

const actionCreator = actionCreatorFactory();

export interface ISetSearchActionPayload {
  searchText: string;
  searchFilter: string;
  searchCategory: string;
}

export const loadCalendarSettingsAddEditEvent_Success = actionCreator<ICalendarSettingsFromService_AddEditEvent>(types.LOAD_CALENDAR_SETTINGS_ADD_EDIT_EVENT_SUCCESS);

const dataService = new DataService();

export function requestCalendarSettingsForAddEditScreenFromService(portletInstanceId: number, calendarId: number, eventId: number) {
  return (dispatch) => {

    dispatch(beginAjaxCall());

    return dataService.textForAddOrEditEvent(portletInstanceId, calendarId, eventId).then((response: any) => {

      if (response.d !== undefined) { response = response.d; } // .NET service wraps response in a 'd' property.

      const calSettingsFromService: ICalendarSettingsFromService_AddEditEvent = response;

      // Populate calendar settings object with results of request.
      const calSettings: ICalendarSettingsFromService_AddEditEvent = {
        addEditText: calSettingsFromService.addEditText,
        currentDateOnServer: calSettingsFromService.currentDateOnServer,
      };

      // If all's well, dispatch action with the calendar settings.
      dispatch(loadCalendarSettingsAddEditEvent_Success(calSettings));

    }).catch((error) => {
      toastr.error(error);
    });
  };
}
